module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Gimnasia.58ea96de.png";